module.exports = __webpack_public_path__ + "static/DenisSavage-1c7058f8c6509b5137e0d9a6f53dcacb.jpg";